import React from 'react';
import { Container, Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Icon from '../UI/Icon';
import memoryGameIcon from '../../assets/memoryGame.png';
import storyTellIcon from '../../assets/storyTell.png';
import connectWordsIcon from '../../assets/connectWords.png';
import searchImagesIcon from '../../assets/searchImages.png';
import minimalPairIcon from '../../assets/minimalPair.png';

function GamesOverview({ onGameSelect }) {
  const games = [
    {
      id: 'memory',
      title: 'Zwillingspaare finden',
      description: 'Finde passende Kartenpaare mit Wörtern und übe dabei spezifische Ziellaute.',
      iconName: 'memory',
      color: '#B8D4E3',
      features: ['Buchstabenauswahl', 'Verschiedene Wortsets', 'Anpassbare Schwierigkeit']
    },
    {
      id: 'story',
      title: 'Geschichte erzählen',
      description: 'Wähle Bilder aus und lass dein Kind dazu Geschichten erzählen',
      iconName: 'story',
      color: '#C7E9C7',
      features: ['Bildauswahl', 'Kreatives Erzählen', 'Sprachförderung']
    },
    {
      id: 'wordmatch',
      title: 'Wörter verbinden',
      description: 'Verbinde zusammengehörende Wörter, bilde daraus kurze Sätze und übe dabei spielerisch deine Ziellaute, während du gleichzeitig deinen Wortschatz erweiterst',
      iconName: 'wordmatch',
      color: '#FFF3CD',
      features: ['Wortpaare', 'Verschiedene Kategorien', '3 Schwierigkeitsstufen']
    },
    {
      id: 'suchbilder',
      title: 'Sprechhelden auf Lautsuche',
      description: 'Suchen Sie gemeinsam in den Bildern nach Objekten mit ihrem Ziellaut',
      iconName: 'search',
      color: '#FFD3E1',
      features: ['Lautsuche', 'Interaktive Bilder', 'Verschiedene Szenen']
    },
    {
      id: 'minimalpair',
      title: 'Laut-Detektive',
      description: 'Höre genau hin und versuche deine Ziellaute herauszuhören',
      iconName: 'speaker',
      color: '#E4D0E4',
      features: ['Hörtraining', 'Ähnliche Wörter', 'Lautunterscheidung']
    }
  ];

  return (
    <Container>
      <div className="text-center mb-5">
        <h2>
          Spiele
        </h2>
        <p className="text-secondary">
          Wähle ein Spiel aus, um spielerisch die Sprachentwicklung zu fördern
        </p>
      </div>

      <Row className="g-4">
        {games.map(game => (
          <Col key={game.id} md={6} lg={4}>
            <Card
              className={`game-overview-card h-100 ${game.comingSoon ? 'coming-soon' : ''}`}
              onClick={() => !game.comingSoon && onGameSelect(game.id)}
              style={{ 
                cursor: game.comingSoon ? 'default' : 'pointer',
                border: '2px solid #dee2e6',
                borderRadius: '15px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                if (!game.comingSoon) {
                  e.currentTarget.style.backgroundColor = '#FFE4B5';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (!game.comingSoon) {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.transform = 'scale(1)';
                }
              }}
            >
              <Card.Body>
                <div className="text-center mb-4">
                  <div style={{ height: '180px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img 
                      src={
                        game.id === 'memory' ? memoryGameIcon : 
                        game.id === 'story' ? storyTellIcon :
                        game.id === 'wordmatch' ? connectWordsIcon :
                        game.id === 'suchbilder' ? searchImagesIcon :
                        minimalPairIcon
                      } 
                      alt={game.title}
                      style={{ 
                        width: game.id === 'minimalpair' ? '225px' : 
                               game.id === 'suchbilder' ? '200px' : '250px', 
                        height: game.id === 'minimalpair' ? '225px' : 
                                game.id === 'suchbilder' ? '200px' : '250px', 
                        objectFit: 'contain' 
                      }}
                    />
                  </div>
                </div>
                
                <h4 className="text-center mb-3">{game.title}</h4>
                <p className="text-secondary text-center mb-4">{game.description}</p>
                

                {game.comingSoon && (
                  <div className="coming-soon-badge">
                    Bald verfügbar
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default GamesOverview;